import React, { useContext } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { useLocation } from "react-router-dom";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";

import { DataContext } from "../context/DataContext";
import { simpleMessage } from "../helpers/Helpers";
import { getPageTitle } from "../helpers/pageTitles";
import { changeThemeAsync, getToken } from "../api/Account";
import SucursalSelector from "./ui/SucursalSelector";

const NavBarElements = () => {
  const token = getToken();
  const location = useLocation();

  const { isDarkMode, setIsDarkMode, setIsLoading, docTitle } =
    useContext(DataContext);

  const changeTheme = async () => {
    setIsLoading(true);
    const resul = await changeThemeAsync(token);
    if (!resul.statusResponse) {
      setIsLoading(false);
      simpleMessage("No se pudo cambiar el tema", "error");
      return;
    }

    setIsDarkMode(!isDarkMode);
    setIsLoading(false);
  };

  const { title, sub } = getPageTitle(location.pathname, docTitle);

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: "16px" }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: 15.5, fontWeight: 600, color: "text.primary", letterSpacing: "-.2px" }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: 11.5, color: "text.secondary" }}>{sub}</Typography>
      </Box>

      <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "14px" }}>
        <SucursalSelector />
        <IconButton
          onClick={changeTheme}
          title="Cambiar tema"
          sx={{
            width: 38,
            height: 38,
            borderRadius: "9px",
            border: "1px solid",
            borderColor: "divider",
            "&:hover": { borderColor: "#00a152" },
          }}
        >
          {isDarkMode ? <LightModeRoundedIcon sx={{ fontSize: 19 }} /> : <DarkModeRoundedIcon sx={{ fontSize: 19 }} />}
        </IconButton>
      </Box>
    </Box>
  );
};

export default NavBarElements;
